export default "__VITE_ASSET__BJvYY7gi__"